import React, { useEffect, useState } from "react";
import { Modal } from "react-bootstrap";
import leave from "../../../assets/img/leave.svg"
import star from "../../../assets/img/star.svg"
import {saveFavouriteMember} from "../../../services/apiPosts";
import ResponsePopup from "../../../commonComponents/responseSucessPopup";
const MakeFavourite = (props)=>{
const contactName = props.favouriteUserName || "this contact";  
const Group = require("../../../assets/img/Featured icon.jpg");
const userData = JSON.parse(localStorage.getItem('userData'));
const[ResponseMessage,SetResponseMessage]=useState("");
const[isSucess,SetSucess]=useState(false);
const closePopup =() =>{
  props.HideFavourite();
}
const makeFavourite=async()=>{
  let favpayload={userid:userData._id,favouritememberid:props.favouriteUserId};
  let favres = await saveFavouriteMember(favpayload);
  let favStatus="";
  if(favres.status === true){
    //const favStatus = !props.FavStatus;
    const newStatus = !props.FavStatus;
    //props.toggleFavourite(props.favouriteUserId,favStatus);
     props.toggleFavourite(props.favouriteUserId, !props.FavStatus);
      closePopup();
    const message = newStatus  ? contactName +" has been added to your Favorites list" : contactName+ " removed from your Favorites list!";
    SetSucess(true);
    SetResponseMessage(message);
   
  }
}
return(
<div>
      <Modal show={props.showFavourite} onHide={props.HideFavourite}
       dialogClassName="small-custom-modal  modal-dialog-centered">
        <Modal.Header closeButton>
        <div className="popupheader">
        <div className="mod-bor-icon" >
        <img src={star} className="mod-icon"></img>
            </div>
            <div className="header">
              <div className="signuup">{props.FavStatus 
    ? `Remove From Favorites list`
    : `Add To Favorites list?`}</div>
              <p className="Stronger">Quickly access your Favorites and include them in Group Messages</p>
            </div>
          </div>
        </Modal.Header>

        <Modal.Body>
          <div>
          <p className="fov-text">{props.FavStatus === true ?(`Do you want to remove ${contactName} fom your favorites list?`):(`Do you want to add ${contactName} to your favorites list?`)}</p>
          </div>
       
        </Modal.Body>

          <Modal.Footer className="full-w" >
                         <button type="button" className="cancel-btn" onClick={()=>closePopup()}>No</button>
                          <button className="next-btn"  onClick={()=>makeFavourite()}>Yes</button>
                </Modal.Footer>
      
      </Modal>
       {isSucess && (<ResponsePopup 
                            isSucess={isSucess} 
                            CancelPopup={() => { 
                             SetSucess(false);
                            }} 
                            message={ResponseMessage}
                          />)}
    </div>
);
  

};
export default MakeFavourite;